import { createReducer } from 'utils'
import { fromJS } from 'immutable'
import { constants } from 'common/actions/projects'

export const initialState = fromJS({
  isLoaded: true,
  isSubmitting: false,
  error: null
})

export default createReducer(initialState, {
  [constants.UPDATE_PROJECT_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.UPDATE_PROJECT_REQUEST.SUCCESS]: () => {
    return initialState
  },
  [constants.UPDATE_PROJECT_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  }
})
